import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3c4fe4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c3c4fe4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c4fe4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c4fe4c')) {
      api.createRecord('c3c4fe4c', component.options)
    } else {
      api.reload('c3c4fe4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3c4fe4c&scoped=true", function () {
      api.rerender('c3c4fe4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/districtManagement/index.vue"
export default component.exports